/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-CMS Content Preview API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ContentPreviewOverviewResultsRestDto } from '../models';
import { ContentPreviewRestDto } from '../models';
/**
 * ContentPreviewEndpointsApi - axios parameter creator
 * @export
 */
export const ContentPreviewEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns one content preview by id, scoped to the customer identified by x-dp-customer-code.
         * @summary REST.API.CMS.CPRV.02 Get a content preview.
         * @param {string} content_preview_id Uniquely identifies the content preview.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language possible application errors are expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentPreviewById: async (content_preview_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'content_preview_id' is not null or undefined
            if (content_preview_id === null || content_preview_id === undefined) {
                throw new RequiredError('content_preview_id','Required parameter content_preview_id was null or undefined when calling getContentPreviewById.');
            }
            const localVarPath = `/content_preview/v1/content_preview/{content_preview_id}`
                .replace(`{${"content_preview_id"}}`, encodeURIComponent(String(content_preview_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the content previews belonging to the customer identified by x-dp-customer-code. Read-only: content previews are provisioned via SQL seed only, there is no create/update/delete/status endpoint.
         * @summary REST.API.CMS.CPRV.01 Get an overview of the content previews.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language possible application errors are expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentPreviewOverview: async (x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/content_preview/v1/content_preview/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentPreviewEndpointsApi - functional programming interface
 * @export
 */
export const ContentPreviewEndpointsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns one content preview by id, scoped to the customer identified by x-dp-customer-code.
         * @summary REST.API.CMS.CPRV.02 Get a content preview.
         * @param {string} content_preview_id Uniquely identifies the content preview.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language possible application errors are expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContentPreviewById(_axios: AxiosInstance, content_preview_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentPreviewRestDto>> {
            const localVarAxiosArgs = await ContentPreviewEndpointsApiAxiosParamCreator(configuration).getContentPreviewById(content_preview_id, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns the content previews belonging to the customer identified by x-dp-customer-code. Read-only: content previews are provisioned via SQL seed only, there is no create/update/delete/status endpoint.
         * @summary REST.API.CMS.CPRV.01 Get an overview of the content previews.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language possible application errors are expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContentPreviewOverview(_axios: AxiosInstance, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentPreviewOverviewResultsRestDto>> {
            const localVarAxiosArgs = await ContentPreviewEndpointsApiAxiosParamCreator(configuration).getContentPreviewOverview(x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ContentPreviewEndpointsApi - object-oriented interface
 * @export
 * @class ContentPreviewEndpointsApi
 * @extends {BaseAPI}
 */
export class ContentPreviewEndpointsApi extends BaseAPI {
    /**
     * Returns one content preview by id, scoped to the customer identified by x-dp-customer-code.
     * @summary REST.API.CMS.CPRV.02 Get a content preview.
     * @param {string} content_preview_id Uniquely identifies the content preview.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [x_dp_language] Indicates in which language possible application errors are expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPreviewEndpointsApi
     */
     public getContentPreviewById(content_preview_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return ContentPreviewEndpointsApiFp(this.configuration).getContentPreviewById(this.axios, content_preview_id, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the content previews belonging to the customer identified by x-dp-customer-code. Read-only: content previews are provisioned via SQL seed only, there is no create/update/delete/status endpoint.
     * @summary REST.API.CMS.CPRV.01 Get an overview of the content previews.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [x_dp_language] Indicates in which language possible application errors are expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentPreviewEndpointsApi
     */
     public getContentPreviewOverview(x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return ContentPreviewEndpointsApiFp(this.configuration).getContentPreviewOverview(this.axios, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

}
